import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import storeLoader from 'app/stores/storeLoader';
import CreditUtilization from 'app/views/synthetics/components/dashboard/CreditUtilization';
import WidgetFrame from '../WidgetFrame';

@storeLoader('$syn.tests', '$syn.agents')
@inject('$syn')
@observer
class CreditUtilizationWidget extends Component {
  constructor(props) {
    super(props);

    const { $syn } = props;

    $syn.plan.loadUsageData();
  }

  render() {
    const { $syn, canCustomize, onRemove, ...props } = this.props;

    return (
      <WidgetFrame canCustomize={canCustomize} onRemove={onRemove} title="Credit Utilization" {...props}>
        <CreditUtilization loading={$syn.tests.loading || $syn.plan.loading || $syn.plan.loadingUsage} isWidgetView />
      </WidgetFrame>
    );
  }
}

export default CreditUtilizationWidget;
